import React, { useState } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { compose } from 'redux';
import { connect } from 'react-redux';

// GLOBAL COMPONENTS
import Sprite from 'core/tools/Sprite';

// LOCAL COMPONENTS
import Branding from './parts/Branding';
import DealershipSelect from './parts/DealershipSelect';
import MenuToggle from './parts/MenuToggle';
import SearchForm from './parts/SearchForm';
import UserButton from './parts/UserButton';
import UserMenu from './parts/UserMenu';
import HeaderMenu from './layout/HeaderMenu';

// STYLES
import styles from './header.module.scss';

// CHILD COMPONENTS
const Divider = () => <div className={clsx(
  'divider',
  styles.divider
)} />;

// MAIN COMPONENT
const Header = compose(
  connect(
    ({ mobile }) => ({ mobile })
  )
)(({
  className,
  // REDUX STATE
  mobile
}) => {
  const [show, setShow] = useState(false)
  return (
    <header
      className={
        clsx((!show || !mobile.mobile) &&
        styles.searchHeader,
        'header',
        'theme-dark',
        styles.header,
        styles.dark,
        className
      )}
    >
      { !show && <Branding /> }

      { !mobile.mobile &&
        <div className={styles.dealership}>
          <DealershipSelect />
        </div>
      }
      <div className={styles.tools}>
        { !mobile.mobile ? (
          <>
            <SearchForm />
            <Divider />
            { !!mobile.xl &&
              <>
                <UserButton />
                <Divider />
              </>
            }
            <div className={styles.menuToogle}><UserMenu /></div>
          </>
        ) : (
          <>
            { !show ?
              <HeaderMenu
                onShow={(e) => setShow(e)}
                toggle={{
                  icon: 'search'
                }}
              /> :
              <div className='d-flex align-items-center mt-4'>
                <SearchForm />
                <div className='ms-3' onClick={() => setShow(false)}>
                  <Sprite use='cancel' size='xl' />
                </div>
              </div>
            }
            { !show &&
              <>
                <Divider />
                <MenuToggle />
              </>
            }
          </>
        )}
      </div>
    </header>
  )
})

export default Header
